// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"141":"3ecbaab7faeaf07bf3aa","315":"00325c7692a3685bd2f7"}[chunkId] + ".bundle.js";
};